import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { useHistory } from 'react-router-dom';
import { GlobalFooter } from '@nexus/fff-global-footer';

import withDocumentTitle from 'HOC/withDocumentTitle/withDocumentTitle';
import withViewSize from 'HOC/withViewSize/withViewSize';

import GlobalNav from 'shared-components/GlobalNav/GlobalNav';
import OrderConfirmation from './OrderConfirmation';

const OrderConfirmationPage = ({
  firstName,
  lastName,
  shippingAddress,
  order,
  viewSize,
}) => {
  const history = useHistory();
  if (!order) {
    history.push('/shop/checkout');
    return null;
  }

  return (
    <div className={viewSize}>
      <GlobalNav hideCart />
      <OrderConfirmation
        firstName={firstName}
        lastName={lastName}
        shippingAddress={shippingAddress}
        order={order}
      />
      <GlobalFooter />
    </div>
  );
};

const mapStateToProps = (state) => ({
  firstName: state.userState.firstName,
  lastName: state.userState.lastName,
  shippingAddress: state.userState.shippingAddress,
  order: state.invoicesState.order,
  viewSize: state.viewState.viewSize,
});

export default compose(
  withDocumentTitle,
  withViewSize,
  connect(mapStateToProps, {})
)(OrderConfirmationPage);
